import { render, staticRenderFns } from "./governanceDashboard.vue?vue&type=template&id=f570b6ee"
import script from "./governanceDashboard.vue?vue&type=script&lang=js"
export * from "./governanceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports